/*
* class AppFunctions
*/

var AppFunctions = function() {

    /*
    * Env variables
    */
    // var $main  = $('#main_wrapper')
    var slides = []


    /*
    * OVerlays
    */

    // var controlOverlay = function() 
    // {
    //     PAtools.getBody().on('click','.main-overlay',function(){

    //         var $this = $(this);

    //         closeOverlay($this);
    //     });

    //     PAtools.getBody().on('click','.main-overlay .content-overlay',function(event){

    //         event.stopPropagation();
    //     });

    //     PAtools.getBody().on('click','[data-overlay]', function(event){

    //         event.preventDefault()

    //         var $this  = $(this),
    //             data   = $this.data()

    //         loadOverlay(data)
    //     })

    //     PAtools.getBody().on('click','.close-overlay,[data-close-overlay]',function(event){

    //         var $overlay = $(this).parents('.main-overlay');

    //         $overlay.addClass('close');

    //         PAtools.getBody().removeClass('overled');

    //         setTimeout(function(){

    //             $overlay.remove()
    //         },300)
    //     })
    // }

    // var loadOverlay = function(data) 
    // {
    //     PAtools.getBody().addClass('overled');

    //     var terrains   = PAtools.getLocal(pa.localstorage,'selection_terrains'),
    //         maisons    = PAtools.getLocal(pa.localstorage,'selection_maisons'),
    //         programmes = PAtools.getLocal(pa.localstorage,'selection_programmes'),
    //         surface    = PAtools.getLocal(pa.localstorage,'surfaceterrain')

    //     var selection = {
    //         'selection_terrains'   : terrains   ? terrains   : [],
    //         'selection_maisons'    : maisons    ? maisons    : [],
    //         'selection_programmes' : programmes ? programmes : [],
    //         'surfaceterrain'       : surface    ? surface    : ''
    //     };

    //     var params = serialize(selection);

    //     $.ajax({
    //         url  : '/ajax/'+data.overlay+'?'+params,
    //         data : data,
    //         type : 'GET',
    //         beforeSend: function(){

    //             if($('.main-overlay').length > 0)
    //                 $('.main-overlay').remove()

    //             var $tploverlay = $('<div id="action-'+data.overlay+'" class="main-overlay"><div class="loader loading"><div></div></div></div>');
    //             PAtools.getBody().append($tploverlay);
    //         }
    //     }).done(function(data){
            
    //         var $overlay = $('.main-overlay');

    //         $overlay.find('.loader').removeClass('loading');
    //         $overlay.append(data);

    //         // controlOverlay();
    //     });
    // }

    // var closeOverlay = function(node)
    // {

    //     node.addClass('close');
    //     setTimeout(function(){
                
    //         node.remove();
    //         PAtools.getBody().removeClass('overled');

    //         $(window).resize();

    //     },750);
    // }

    /*
    * front
    */

    var controlForm = function()
    {
       let inputs = document.querySelectorAll(' input');

       for (let index = 0; index < inputs.length; index++) {
           
           let input = inputs[index];

           input.addEventListener('focus', function(){

               let label = input.parentNode.previousSibling;
               
               label.classList.add('focus');
           })

           input.addEventListener('blur', function(){

               let label = input.parentNode.previousSibling;
               
               if( input.value != '' ) {
                   label.classList.add('not-empty');
               }else{
                   label.classList.remove('not-empty');
               }

               label.classList.remove('focus');
           })
       }
    }

    var controlResp = function()
    {
        // Exemple actions pour responsive
        // let togglemenu = document.getElementById('toggle_menu')
        // let menublock  = document.getElementById('resp_menu')
        // let holdmenu   = document.getElementById('hold_resp_menu')

        // var trait = function(event){
        //     var res = ['m','sm','s'];
        //     if( !res.includes(PAtools.getScreenType()) )
        //         return;
         
        //     event.preventDefault()

        //     if( menublock.classList.contains('open') ){
        //         menublock.classList.remove('open')
        //         document.body.classList.remove('overled')
        //     }
        //     else{
        //         menublock.classList.add('open')
        //         document.body.classList.add('overled')
        //     }
        // }

        // menublock.addEventListener('touchstart', trait)
        // menublock.addEventListener('click', trait)

        // holdmenu.addEventListener('click', function(event){
        //     event.stopPropagation()
        // })
        // holdmenu.addEventListener('touchstart', function(event){
        //     event.stopPropagation()
        // })
    }

    var scrollActions = function()
    {
        
        let links = document.querySelectorAll('a[href^="#"]');
        
        
        for (let index = 0; index < links.length; index++) {
            
            let anchor = links[index];
            anchor.addEventListener('click', function (event) {
                event.preventDefault();
                let target    = document.querySelector(anchor.getAttribute('href'));
                let bodyrect  = document.body.getBoundingClientRect();
                let targetpos = target.getBoundingClientRect();
                
                // window.scroll({
                //     top: targetpos.top - bodyrect.top - headbar.offsetHeight - 15, 
                //     behavior: 'smooth' 
                // });

                var isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
                var options = {
                    "behavior": "smooth",
                    "left": 0,
                    "top":  targetpos.top - bodyrect.top - headbar.offsetHeight - 15
                };

                if (isSmoothScrollSupported) {
                    window.scrollTo(options);
                } else if (window.jQuery && jQuery.scrollTo) {
                    $(window).scrollTo(options.top, options.left);
                } else {
                    window.scrollTo(options.left, options.top);
                }
            });
        }
    }

    var effects3D = function()
    {
        
        let blocks = document.querySelectorAll('.visu-effect');
        let images = [];
        
        for (let i = 0; i < blocks.length; ++i) {
            
            let block = blocks[i];
            let visus = block.querySelectorAll('img');
            
            for (let i = 0; i < visus.length; ++i) {

                let visu = visus[i];
                images.push(visu);
            }
        }
        
        document.body.onmousemove = function(e) {

            for (let i = 0; i < images.length; ++i) {

                let img      = images[i];
                let movement = img.dataset.move;
                let width    = img.innerWidth ? img.innerWidth:   img.width;
                let height   = img.innerHeight ? img.innerHeight: img.height;
                TweenMax.to(img, 1, {
                    x: (e.clientX - width / 2) / width * movement,
                    y: (e.clientY - height / 2) / height * movement
                });
            }
        }

        if (window.DeviceOrientationEvent) {

            window.addEventListener("deviceorientation", function(event) {
                for (let i = 0; i < images.length; ++i) {
                    let img      = images[i];
                    let movement = img.dataset.move;
                    processGyro(event.alpha, event.beta, event.gamma, img, movement);
                }
            }, true);

            function processGyro(alpha, beta, gamma, img, movement) {
                TweenMax.to(img, 1, {
                    x: (gamma * (movement / 4)),
                    y: (beta * (movement / 4))
                });
            }
        }
    }

    return {

        /*
        * Main class initializer
        */

        init: function() {
            AppFunctions.initComponents();

            while (pagefunctions.length){
                pagefunctions.shift().call();
            }
        
            if(typeof launchFunction == 'function')
                launchFunction()
        },

        /*
        * Initializes components
        */

        initComponents: function() {
            
            // controlOverlay()
            scrollActions()
            controlResp()
            effects3D()
            controlForm()
            // controlSlides()

            // loadOverlay({'overlay':'contactform'})

            // $(window).resize(function() {
                // controlResp()
            // })
        },

        initForm: function(id) {

            return ajaxForm(id)
        },

        loadOverlay: function(slug) {
            loadOverlay(slug)
        }
    };

}();

(function() {

    // AppFunctions.init();    

})();